import { useDispatch, useSelector } from 'react-redux';
import {
  closeDialogAction,
  closeMobileNarvarAction,
  closeNarvarAction,
  foldNarvarAction,
  globalClearAction,
  hideSnackbarAction,
  openDialogAction,
  openMobileNarvarAction,
  openNarvarAction,
  showSnackbarAction,
  SnackbarOptions,
  toggleMobileNarvarAction,
  toggleNarvarAction,
  unfoldNarvarAction,
} from './store/reducer';
import {
  dialogSelector,
  foldedSelector,
  mobileOpenedSelector,
  openedSelector,
  snackbarOpenSelector,
  snackbarMessageSelector,
  snackbarOptionsSelector,
} from './store/selector';

export function useGlobalCore() {
  const opened = useSelector(openedSelector);
  const folded = useSelector(foldedSelector);
  const mobileOpened = useSelector(mobileOpenedSelector);
  const dialog = useSelector(dialogSelector);
  const snackbarOpen = useSelector(snackbarOpenSelector);
  const snackbarMessage = useSelector(snackbarMessageSelector);
  const snackbarOptions = useSelector(snackbarOptionsSelector);
  const dispatch = useDispatch();

  return {
    opened,
    folded,
    mobileOpened,
    dialog,
    toggleNarvar: () => dispatch(toggleNarvarAction()),
    openNarvar: () => dispatch(openNarvarAction()),
    closeNarvar: () => dispatch(closeNarvarAction()),
    foldNarvar: () => dispatch(foldNarvarAction()),
    unfoldNarvar: () => dispatch(unfoldNarvarAction()),
    toggleMobileNarvar: () => dispatch(toggleMobileNarvarAction()),
    openMobileNarvar: () => dispatch(openMobileNarvarAction()),
    closeMobileNarvar: () => dispatch(closeMobileNarvarAction()),
    openDialog: (dialog: string) => dispatch(openDialogAction(dialog)),
    closeDialog: () => dispatch(closeDialogAction()),
    clearGlobal: () => dispatch(globalClearAction()),
    snackbarOpen,
    snackbarMessage,
    snackbarOptions,
    showSnackbar: (payload: { message: string; options?: Partial<SnackbarOptions> }) =>
      dispatch(showSnackbarAction(payload)),
    hideSnackbar: () => dispatch(hideSnackbarAction()),
  };
}
